import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRedirect, DomainRoute } from '../utils/domain/routingComponents'
import { marketingToolingAccessControl } from '../access-control/marketingToolingAccess.configuration'
import { marketingToolingSegmentLibraryAccessControl } from '../access-control/marketingToolingSegmentLibraryAccess.configuration'
import { standaloneUnsubscribeListsAccessControl } from '../access-control/standaloneUnsubscribeListsAccess.configuration'

const ListPage = lazy(() => import('../pages/scoped/List'))
const CreatePage = lazy(() => import('../pages/scoped/Create'))
const EditPage = lazy(() => import('../pages/scoped/Edit'))
const ViewPage = lazy(() => import('../pages/scoped/View'))
const SegmentLibraryPage = lazy(() => import('../pages/scoped/SegmentLibrary'))
const UnsubscribeListPage = lazy(() => import('../pages/scoped/UnsubscribeList'))

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const marketingToolingScopedRouter = (
  <DomainRoute
    route="app-marketing-tooling-campaigns"
    accessControl={marketingToolingAccessControl}
  >
    <DashSwitch>
      <DomainRoute exact route="app-marketing-tooling-campaigns" component={ListPage} />
      <DomainRoute exact route="app-marketing-tooling-campaigns-create" component={CreatePage} />
      <DomainRoute exact route="app-marketing-tooling-campaigns-edit" component={EditPage} />
      <DomainRoute exact route="app-marketing-tooling-campaigns-view" component={ViewPage} />

      {/* Redirect to the list page by default */}
      <DomainRedirect toRoute="app-marketing-tooling-campaigns" />
    </DashSwitch>
  </DomainRoute>
)

export const marketingToolingSegmentLibraryRouter = (
  <DomainRoute
    exact
    route="app-marketing-tooling-segment-library"
    accessControl={marketingToolingSegmentLibraryAccessControl}
    component={SegmentLibraryPage}
  />
)

export const marketingToolingUnsubscribeListRouter = (
  <DomainRoute
    exact
    route="app-marketing-tooling-unsubscribe-list"
    accessControl={standaloneUnsubscribeListsAccessControl}
    component={UnsubscribeListPage}
  />
)
